import { Dashboard } from "./dashboard/Dashboard";

export const DashboardContainer = () => {
  return <Dashboard />;
};

export default DashboardContainer;
